import { Controller } from "@hotwired/stimulus"

// Web half of the account menu (layouts/_mobile_profile_button): a dropdown
// panel under the avatar. Stays out of the way in the native shell, where
// bridge/account_menu_controller.js hands the menu to a native popover.
export default class extends Controller {
  static targets = ["button", "panel"]

  connect() {
    this.close = this.close.bind(this)
    this.onDocumentClick = this.onDocumentClick.bind(this)
    this.onKeydown = this.onKeydown.bind(this)
    // Never leave an open panel in Turbo's snapshot cache.
    document.addEventListener("turbo:before-cache", this.close)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.close)
    this.removeDismissListeners()
  }

  toggle(event) {
    if (this.nativeHandlesMenu) return
    event.preventDefault()
    this.isOpen ? this.close() : this.open()
  }

  open() {
    this.panelTarget.classList.remove("d-none")
    requestAnimationFrame(() => this.panelTarget.classList.add("is-open"))
    this.buttonTarget.setAttribute("aria-expanded", "true")
    document.addEventListener("click", this.onDocumentClick, true)
    document.addEventListener("keydown", this.onKeydown)
    window.addEventListener("scroll", this.close, true)
  }

  close() {
    if (!this.hasPanelTarget || !this.isOpen) return
    this.panelTarget.classList.remove("is-open")
    this.panelTarget.classList.add("d-none")
    this.buttonTarget.setAttribute("aria-expanded", "false")
    this.removeDismissListeners()
  }

  onDocumentClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close()
  }

  removeDismissListeners() {
    document.removeEventListener("click", this.onDocumentClick, true)
    document.removeEventListener("keydown", this.onKeydown)
    window.removeEventListener("scroll", this.close, true)
  }

  get isOpen() {
    return this.hasPanelTarget && !this.panelTarget.classList.contains("d-none")
  }

  // The shell lists its bridge components in the user agent; when
  // "account-menu" is among them the native popover owns the tap.
  get nativeHandlesMenu() {
    const match = navigator.userAgent.match(/bridge-components: \[(.*?)\]/)
    return !!match && match[1].split(" ").includes("account-menu")
  }
}
